export default {
      evidence: {
        client_ip: "클라이언트 IP",
        list: "증거 흔적 목록",
        new_content: "새 콘텐츠",
        old_content: "이전 콘텐츠",
        request_type: "요청 유형",
        time_access: "시간 액세스",
        update: "증거 흔적 세부 사항",
        uri: "URI",
        user: "사용자",
        work_content : "업무 내용",
        division: "구분 유형",
        connection_screen: "연결 화면",
        work_content: "업무 내용",
        before: "이전",
        after: "애프터",
        status: "지위",
        login_history_update: "로그인 기록 세부 사항",
        sessionId: "Session Id",
        fullName: "성명"
      },
}